<div class="ui modal" id="TicketKeyboardModal" style="position:absolute;left:40%;bottom:15%; width:500px !important;">

  <div class="header" style="display:flex;">
    <div style="background-color:black;width:85%;color:white;"><span style="margin-left:10px"></span></div>
    <div style="background-color:black;width:15%;margin-left:10px">
      <button style="float:right;background-color:black;color:white;width:100%" class="ui icon button" (click)="ReadPayoutSlip_Close()">
        <i class="remove link icon"></i>
      </button>
    </div>
  </div>

  <div class="content">
    <div class="ui fluid input">
      <input placeholder="Ticket Number" style="text-align:right;height:55px;font-size:15px;background-color:gainsboro;width:60% !important" type="text" [(ngModel)]="this.tournamentsService.PayoutSlipNumber"   value="{{this.tournamentsService.PayoutSlipNumber}}" (focus)="ReadPayoutSlip_TicketNumber()">


      <input placeholder="Ticket Password" style="text-align:right;height:55px;font-size:15px;background-color:gainsboro;width:35% !important;margin-left:25px" type="text" [(ngModel)]="this.tournamentsService.PayoutSlipPassword"   (focus)="ReadPayoutSlip_TicketPassword()">
    </div>
  </div>
  <div *ngIf="this.tournamentsService.readPayoutErrorVisible==1"  class="inline field" style="text-align: center;color:red;">


    <span>{{this.tournamentsService.readPayoutError}}</span>

  </div>
  <div class="content">
    <div class="ui grid segment" style="height:412px;background-color:gainsboro;">
      <table class="ui table" id="ReadPayoutSlip_Modal_ButtonTable" style="background-color:gainsboro;">
        <tr>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(1)">1</button>
          </td>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(2)">2</button>
          </td>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue('3')">3</button>
          </td>
          <td rowspan="2" class="four wide">
            <button class="ui fluid icon button" style="height:170px;width:70px;background:black;color:white;" (click)="ReadPayoutSlip__Cancel()">
              <i class="big arrow left icon"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(4)">4</button>
          </td>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(5)">5</button>
          </td>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(6)">6</button>
          </td>
        </tr>
        <tr>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(7)">7</button>
          </td>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(8)">8</button>
          </td>
          <td class="four wide">
            <button class="ReadPayoutSlipButton" (click)="ReadPayoutSlip_ChangeValue(9)">9</button>
          </td>
          <td rowspan="2" class="four wide">
            <button class="ui fluid button" style="height:170px;width:70px;background:black;color:white;" (click)="ReadPayoutSlipOk()">
              OK
            </button>
          </td>
        </tr>
        <tr style="height:102px">
          <td></td>


        </tr>

      </table>
      <button class="SettingLoginButton" style="color:white;width:296px; height: 71px;position:relative;bottom: 103px;margin-left:25px;" (click)="ReadPayoutSlip_ChangeValue(0)">
        0
      </button>
    </div>
  </div>

</div>
